import _ from 'lodash';

export default class AgentAssistanceConfigurationService {
  constructor(pubsub, getDatabase) {
    this.pubsub = pubsub;
    this.getDatabase = getDatabase;
  }

  get(orgId) {
    let agentAssistance = this.getDatabase(orgId).agentAssistanceConfig;
    return _.isPlainObject(agentAssistance)
      ? agentAssistance
      : { errors: [{ code: 'not_exist', detail: 'configuration value [agent-assistance] does not exist' }] };
  }
}



// WEBPACK FOOTER //
// ./src/scripts/infrastructure/backends/fake_backend/agent_assistance_configuration_service.js